/**
 * @class
 * @requires jQuery($)
 * @requires underscore(_)
 */
function CGroupCollection()
{
    this._groups = [];
    this._url = '../../ajax/get_groups.php';
    this._templates = {
        'item': '',
        'list': ''
    };
}

CGroupCollection.prototype.fetch = function( fnCallback )
{
    var self = this;

    $.ajax({
        type: "post",
        url: self._url,
        dataType: "json",

        success: function (data)
        {
            if (data.status === "OK")
            {
                self._groups = data.data;
                fnCallback( null, self._groups );
            }
            else
            {
                fnCallback( 'Problem fetching groups from server', null );
            }
        },
        error: function ()
        {
            throw new Error( 'Problem connecting server' );
        }
    });
};

CGroupCollection.prototype.toArray = function()
{
    return this._groups;
};

CGroupCollection.prototype.setItemTemplate = function( strTemplate )
{
    this._templates.item = strTemplate;
};

CGroupCollection.prototype.renderItem = function( objGroup )
{
    var compiled = kendo.template( this._templates.item );
    return compiled( objGroup );
};

CGroupCollection.prototype.renderCollection = function()
{
    var self = this;
    var renderedCollection = '';

    _.each( this._groups, function( item ) {
        renderedCollection += self.renderItem( item );
    });
    return renderedCollection;
};